import { TableContainer } from "@mui/material";
import { motion } from "motion/react";
import { FC, forwardRef, PropsWithChildren } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const PreviewLineWithArrowStyled = styled.nav.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "preview-line-with-arrow",
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0;
  width: 100%;
  justify-content: initial;
  cursor: pointer;

  .ConflictsCollapseIcon {
    margin-inline-start: auto;
  }
`;
export const MotionExpandedArrow = motion.create(
  forwardRef<SVGSVGElement>((props, ref) => (
    <SVG_MUI.GroupArrowExpandSVG className="ConflictsCollapseIcon" ref={ref} />
  )),
);

const collapseDuration = 0.2;

export const ConflictsCollapseIcon: FC<{
  isExpanded: boolean;
}> = ({ isExpanded }) => {
  return (
    <MotionExpandedArrow
      animate={isExpanded ? "open" : "close"}
      variants={{
        open: {},
        close: { rotate: 180 },
      }}
      transition={{ duration: collapseDuration }}
    />
  );
};

const MotionTableContainer = motion.create(TableContainer);
const DEFAULT_EXPAND_HEIGHT = 400;

interface IExpandedTable extends PropsWithChildren {
  dataE2E?: string;
}

export const ExpandedTable: FC<IExpandedTable> = ({ children, dataE2E }) => {
  return (
    <MotionTableContainer
      key="content"
      initial="collapsed"
      animate="open"
      exit="collapsed"
      data-e2e={dataE2E || "expanded-table"}
      variants={{
        open: { opacity: 1, height: "auto" },
        collapsed: { opacity: 0, height: 0 },
      }}
      transition={{
        duration: collapseDuration,
      }}
    >
      {children}
    </MotionTableContainer>
  );
};

export const ExpandedBlock: FC<
  { blockHeight?: number | string } & PropsWithChildren
> = ({ children, blockHeight = DEFAULT_EXPAND_HEIGHT }) => {
  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: blockHeight, opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: collapseDuration, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};
